export enum DisplayNameControlKeys {
  LEGAL_NAME = 'legal-name',
  PREFERRED_NAME = 'preferred-name',
}

export type DisplayNamePerson = { firstName: string; lastName: string; preferredName?: string };
export type DisplayNameOptions = { alwaysUseLegalName?: boolean };
